"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = require("react");
var _EDSContext = require("../EDSContext/EDSContext");
var _Locales = _interopRequireDefault(require("../StandaloneDatePicker/internal/Locales"));
/**
 * Context provided by the EDSApplication component is required for hook to work
 */
var useDateLocale = function useDateLocale() {
  var edsContext = (0, _react.useContext)(_EDSContext.EDSContext);
  var locale = edsContext.locale;
  return _Locales.default[locale];
};
var _default = exports.default = useDateLocale;